import { v4 as uuid } from 'uuid';

import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { summarizeSchemaPrompt } from 'src/utils/voicebox/prompts/summarizeSchema';
import {
  VoiceboxExistingModelMessage,
  VoiceboxModelSchema,
} from 'src/utils/voicebox/types';

export const createExistingModelMessage = ({
  modelSchema,
}: {
  modelSchema: VoiceboxModelSchema;
}): VoiceboxExistingModelMessage => {
  const content = summarizeSchemaPrompt(modelSchema);
  const classNames = modelSchema.classIris
    .map((iri) => getLabelForIri(modelSchema.labelsByIri, iri))
    .join(', ');
  const humanText = `A model with classes ${classNames}`;
  return {
    role: 'system',
    isExistingModel: true,
    content,
    humanText,
    modelSchema,
    id: uuid(),
  };
};
